"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Compare32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M13.146 12.753a.887.887 0 01-.216-.361 1.34 1.34 0 01-.045-.53c.04-.347.173-.64.404-.871s.521-.36.867-.401l12.702-.116-3.838-3.435c-.311-.19-.47-.456-.482-.792a1.182 1.182 0 01.361-.88c.155-.232.414-.365.781-.401.368-.042.674.067.926.316l6.807 6.004c.094.094.176.233.243.415.068.184.103.374.103.564.021.211-.02.374-.116.49a6.258 6.258 0 01-.373.404l-7.153 5.425c-.313.194-.62.271-.925.231a1.235 1.235 0 01-.751-.346l-.115-.118a1.408 1.408 0 01-.264-.92c.02-.347.179-.626.464-.838l4.732-3.519-13.189-.028a.725.725 0 01-.503-.017 1.305 1.305 0 01-.42-.276zm5.708 6.493c.1.096.167.21.217.36.048.143.063.319.046.531a1.45 1.45 0 01-.404.871 1.427 1.427 0 01-.869.401l-12.7.114 3.84 3.437c.309.191.466.457.479.786.008.342-.111.635-.36.888-.155.229-.415.359-.781.4a1.069 1.069 0 01-.926-.319L.587 20.714a1.193 1.193 0 01-.245-.414 1.625 1.625 0 01-.102-.565c-.017-.21.02-.374.115-.489s.225-.252.375-.408l7.159-5.423c.31-.194.615-.273.922-.232.306.038.558.153.751.347l.115.116c.195.269.28.579.263.921a1.086 1.086 0 01-.463.837l-4.734 3.522 13.19.026a.748.748 0 01.503.014c.164.069.302.165.418.28z" }))); };
var StyledCompare32 = styled_components_1.default(Compare32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledCompare32;
var templateObject_1;
//# sourceMappingURL=Compare32.js.map